<template>
    <div class="search_modular_container">
        <div class="search_modular_left">
            <div class="add_btn btn" @click="open_dialogVisible" v-if="add_name=='新增类型'?hasAccess('249'):hasAccess('245')">{{add_name}}</div>
            <div class="del_btn" @click="open_dialog" v-if="add_name=='新增类型'?hasAccess('251'):hasAccess('247')">删除</div>
        </div>
        <div class="search_modular_right">
            <input class="search_input" v-model="name" @blur="blur" :placeholder="tps" type="text">
            <div class="search_btn" @click="search_click">搜索</div>
        </div>
        <el-dialog
            title="确认要删除选中类型字段？"
            :visible.sync="is_open_dialog"
            width="30%"
            :before-close="handleClose">
            <span>类型内资源也将会全部删除。</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="is_open_dialog = false">取 消</el-button>
                <el-button type="primary" @click="batch_del_click">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { hasAccess } from '@/common/utils'
import { mapState, mapGetters, mapActions } from "vuex";
export default {
    props:{
        add_name:{
            type:String
        },
        modular:{
            type:String
        }
    },
    data(){
        return{
            hasAccess,
            is_open_dialog:false,
            name:'',
            page:1,
            limit:10
        }
    },
    computed:{
        ...mapGetters("type_tube_vuex",['ids','search_name']),
        ...mapGetters("resources_tube_vuex",['resources_ids','search_name']),
        tps(){
            return this.modular == 'type'?'请输入类型名称':'请输入资源名称'
        }
    },
    watch:{
        name(val){
            if(val==''){
                this.$store.commit(`${this.modular}_tube_vuex/set_search_name`,'')
                if(this.modular == 'type'){
                    this.load_type_list()
                }else if(this.modular == 'resources'){
                    this.load_resources_list()
                }
            }
        }
    },
    methods:{
        ...mapActions("type_tube_vuex",['get_type_list']),
        ...mapActions("resources_tube_vuex",['get_oppowallpaper_list']),
        blur(){
            switch(this.modular){
                case 'resources':
                    this.$store.commit("resources_tube_vuex/set_search_name",this.name)
                    break
                case 'type':
                    this.$store.commit("type_tube_vuex/set_search_name",this.name)
                    break
            }
        },
        search_click(){
            if(!this.name){
                this.$message({
                    message:'请输入要搜索的内容',offset: 90,type: 'error'
                });
                return
            }
            switch(this.modular){
                case 'resources':
                    this.load_resources_list()
                    break
                case 'type':
                    this.load_type_list()
                    break
            }
        },
        load_type_list(){
            this.$store.commit("type_tube_vuex/set_page",this.page)
            this.$store.commit("type_tube_vuex/set_limit",this.limit)
            this.get_type_list()
        },  
        load_resources_list(){
            this.$store.commit("resources_tube_vuex/set_page",this.page)
            this.$store.commit("resources_tube_vuex/set_limit",this.limit)
            this.get_oppowallpaper_list()
        },  
        handleClose(){
            this.is_open_dialog = false
        },
        open_dialog(){
            if(this.modular == 'type'){
                if(!this.ids){
                    this.$message({
                        message:'请选择要批量删除的类型',offset: 90,type: 'error'
                    });
                    return
                }
            }else if(this.modular == 'resources'){
                if(!this.resources_ids){
                    this.$message({
                        message:'请选择要批量删除的类型',offset: 90,type: 'error'
                    });
                    return
                }
            }
            
            this.is_open_dialog = true
        },
        open_dialogVisible(){
            this.$emit('open_dialogVisible')
        },
        batch_del_click(){
            this.$emit('batch_del_click')
            this.is_open_dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
.search_modular_container{
    display: flex;
    padding: 50px 30px;
    justify-content: space-between;
    .search_modular_left{
        display: flex;
        .add_btn,.del_btn{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 150px;
            height: 40px;
            background: rgb(80, 139, 248);
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
        }
        .del_btn{
            background: red;
            margin-left: 10px;
        }
    }
    .search_modular_right{
        display: flex;
        .search_input{
            width: 200px;
            height: 40px;
            border: 1px solid #eee;
            padding: 0 10px;
        }
        .search_btn{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 40px;
            background: rgb(41, 115, 212);
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>

<style lang="scss">
.search_modular_container{
    .el-dialog__body{
        padding: 30px !important;
        color: red;
    }
}
</style>